import { Tooltip, Typography } from '@material-ui/core'

import { gregorianToJalaali } from '../../helpers/date'
import { lang } from '../../localization'
import {
  AvailabilityDetails,
  DetailsForEachDate
} from '../../types/monitoringUpdate'
import useStyles from './Styles/AccommodationLayer.style'

interface TimeCellProps {
  dataStatus: DetailsForEachDate | AvailabilityDetails
  range: 'TWO_WEEKS' | 'MONTH'
}
function TimeCell({ dataStatus, range }: TimeCellProps) {
  const classes = useStyles()
  return (
    <Tooltip
      placement="top"
      title={
        lang == 'fa'
          ? gregorianToJalaali(dataStatus.time.split(' ')[0])
          : dataStatus.time.split(' ')[0]
      }>
      <div
        className={[
          classes.status,
          dataStatus.status && dataStatus.status === 'Normal'
            ? classes.normalStatus
            : dataStatus.status === 'Warning'
            ? classes.warningStatus
            : dataStatus.status === 'Critical'
            ? classes.criticalStatus
            : dataStatus.status === 'Unexpected'
            ? classes.unexpectedStatus
            : ''
        ].join(' ')}>
        <Typography
          className={
            range === 'TWO_WEEKS'
              ? classes.textTimeTwoWeeks
              : classes.textTimeMonth
          }>
          {dataStatus.time.split(' ')[1]}
        </Typography>
      </div>
    </Tooltip>
  )
}

export default TimeCell
